import { API_HOST, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/reports`;

const getRetrieveUserMetricsEndpoint = () => `${getEndpoint()}/retrieve/user-metrics`;
export const getRetrieveUserMetricsRequest = (dates) => [getRetrieveUserMetricsEndpoint(), getHttpPostOptions(dates)];

const getDownloadUserMetricsEndpoint = () => `${getEndpoint()}/download/user-metrics`;
export const getDownloadUserMetricsRequest = (dates) => [
  getDownloadUserMetricsEndpoint(),
  getHttpPostOptions(dates, { Accept: 'application/octet-stream' }, undefined, 'blob'),
];

const getRetrieveDealRoomStatisticsEndpoint = () => `${getEndpoint()}/retrieve/deal-room-statistics`;
export const getRetrieveDealRoomStatisticsRequest = (dates) => [
  getRetrieveDealRoomStatisticsEndpoint(),
  getHttpPostOptions(dates),
];

const getDownloadDealRoomStatisticsEndpoint = () => `${getEndpoint()}/download/deal-room-statistics`;
export const getDownloadDealRoomStatisticsRequest = (dates) => [
  getDownloadDealRoomStatisticsEndpoint(),
  getHttpPostOptions(dates, { Accept: 'application/octet-stream' }, undefined, 'blob'),
];
